import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { Logo, GlobalStyles } from "../components/UI";
import { ACCENT, ACCENT2, BORDER, MUTED } from "../utils/constants";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLogin();
    } catch (err) {
      setError(
        err.code === "auth/invalid-credential"
          ? "Invalid email or password"
          : err.code === "auth/too-many-requests"
          ? "Too many attempts. Try again later."
          : "Login failed. Check your credentials."
      );
    }
    setLoading(false);
  };

  const inp = {
    width: "100%", padding: "12px 14px",
    background: "rgba(255,255,255,0.07)",
    border: `1px solid ${BORDER}`,
    borderRadius: 10, color: "#fff",
    fontSize: 15, fontFamily: "DM Sans, sans-serif",
    outline: "none",
  };

  return (
    <div style={{ minHeight: "100vh", background: "#080B18", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "DM Sans, sans-serif" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 40 }}>
        <Logo size={44} />
        <span style={{ fontFamily: "Syne, sans-serif", fontWeight: 700, fontSize: 22, color: "#fff" }}>DialHoop</span>
        <span style={{ fontSize: 11, background: "rgba(124,111,255,0.2)", color: "#a89fff", padding: "3px 10px", borderRadius: 100, letterSpacing: "0.5px", textTransform: "uppercase" }}>Admin</span>
      </div>

      <form onSubmit={handleLogin} style={{ width: "100%", maxWidth: 360, display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ fontFamily: "Syne, sans-serif", fontSize: 22, fontWeight: 700, color: "#fff", marginBottom: 4, textAlign: "center" }}>
          Sign in
        </div>
        <div style={{ fontSize: 14, color: MUTED, textAlign: "center", marginBottom: 8 }}>
          Admin access only
        </div>

        <div>
          <label style={{ fontSize: 12, color: MUTED, display: "block", marginBottom: 5 }}>Email</label>
          <input
            type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder="admin@dialhoop.com" required style={inp} autoComplete="email"
          />
        </div>

        <div>
          <label style={{ fontSize: 12, color: MUTED, display: "block", marginBottom: 5 }}>Password</label>
          <input
            type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="••••••••" required style={inp} autoComplete="current-password"
          />
        </div>

        {error && (
          <div style={{ background: "rgba(231,76,60,0.12)", border: "1px solid rgba(231,76,60,0.3)", borderRadius: 9, padding: "10px 14px", fontSize: 13, color: "#e74c3c" }}>
            {error}
          </div>
        )}

        <button type="submit" disabled={loading} style={{
          background: `linear-gradient(135deg, ${ACCENT}, ${ACCENT2})`,
          color: "#fff", border: "none", padding: "14px",
          borderRadius: 100, fontSize: 15, fontWeight: 600,
          cursor: "pointer", fontFamily: "DM Sans, sans-serif",
          opacity: loading ? 0.7 : 1, marginTop: 4,
        }}>
          {loading ? "Signing in…" : "Sign In →"}
        </button>
      </form>

      <div style={{ marginTop: 32, fontSize: 12, color: "rgba(240,238,248,0.25)", textAlign: "center" }}>
        This page is not publicly listed.
      </div>
      <GlobalStyles />
      <style>{`input::placeholder{color:rgba(240,238,248,0.3);}input:focus{border-color:rgba(124,111,255,0.5)!important;outline:none;}`}</style>
    </div>
  );
}